import CopyItem from './CopyItem';
// card component will be used in tools

import {flags} from '../../../contents/countries/countries';
import enCountryList from '../../../contents/countries/countyList';
import trCountryList from '../../../contents/countries/countryListTr';
import { useRouter } from "next/router";

export default function CardGeo({ title, items, info, entities, hostname }) {

    const router = useRouter();
    const {locale} = router;
    const data = locale === "tr" ?  trCountryList : enCountryList;
    return (
        <div style={{ overflow: "hidden" }}>
            <div className="card-body mb-0 p-2 p-lg-4">
                <h4 className="card-title mt-2 mb-1 font-weight-bold text-secondary line-height-3">
                    {title} </h4>
                {info && <p> {info} </p>}
                <table className="table table-hover">
                    <tbody>
                        {items.map((item, i) => {
                            const iso = items[8] ? items[8].value : "";
                            const country = data[iso]
                            if (i < 8 && item.name !== "TabName") {
                                return (
                                    <tr key={item.name} className="line-height-3">
                                        <td className="py-1 text-4-5 font-weight-bold "> {item.name} </td>
                                        <td className="py-1"> : </td>
                                        <CopyItem
                                            hostname={i===0 && hostname}
                                            flag={i===2 && flags[iso]}
                                            value={item.value}
                                            country={i===2 && country}
                                        />
                                    </tr>
                                )
                            }
                        })}
                        {entities?.['address']?.map(add => <tr className="line-height-3" key={add}>
                            <td className="py-1 text-4-5 font-weight-bold "> {locale === "tr" ? "Adres": "Address"} </td>
                            <td className="py-1"> : </td>
                            <CopyItem
                                value={add}
                            />
                        </tr>)}
                        {entities?.['email']?.map(email => <tr className="line-height-3" key={email}>
                            <td className="py-1 text-4-5 font-weight-bold "> Email </td>
                            <td className="py-1"> : </td>
                            <CopyItem
                                value={email}
                            />
                        </tr>)}
                        {entities?.['phone']?.map(ph => <tr className="line-height-3" key={ph}>
                            <td className="py-1 text-4-5 font-weight-bold "> Phone </td>
                            <td className="py-1"> : </td>
                            <CopyItem
                                value={ph}
                            />
                        </tr>)}
                    </tbody>
                </table>
            </div>
        </div>
    )
}


